import { render, staticRenderFns } from "./ReportGeneratorModalFeedback.vue?vue&type=template&id=389e843a&scoped=true"
import script from "./ReportGeneratorModalFeedback.vue?vue&type=script&lang=js"
export * from "./ReportGeneratorModalFeedback.vue?vue&type=script&lang=js"
import style0 from "./ReportGeneratorModalFeedback.vue?vue&type=style&index=0&id=389e843a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e843a",
  null
  
)

export default component.exports